/* RESPONSIBLE TEAM: team-automation-foundations */
import Route from '@ember/routing/route';
import { inject as service } from '@ember/service';
import type IntlService from 'embercom/services/intl';

export default class AutomationFinAiAgentEcommerceStoreRoute extends Route {
  @service declare intl: IntlService;

  analytics = {
    section: 'automation',
    place: 'fin-ai-agent.ecommerce.store',
  };

  queryParams = {
    notify: { refreshModel: false },
  };

  get titleToken() {
    return this.intl.t('ai-agent.new-submenu.store');
  }
}
